export default "__VITE_ASSET__3cc0a86f__"